import apiFetch from '../apiFetch'

export default function (token, operationType) {
  return apiFetch({ endPoint: 'OperationType', method: 'PUT', body: operationType, token: token })
}
